export enum AysClinicUniversityType {
  WITH_UNIVERSITIES = 'WITH_UNIVERSITIES',
  WITHOUT_UNIVERSITIES = 'WITHOUT_UNIVERSITIES',
  ONLY_UNIVERSITIES = 'ONLY_UNIVERSITIES'
}

export const AYS_CLINIC_UNIVERSITY_TYPE_DISPLAY_NAMES: { [type in AysClinicUniversityType]: string } = {
  [AysClinicUniversityType.WITH_UNIVERSITIES]: 'Mit Universitäts-Kliniken',
  [AysClinicUniversityType.WITHOUT_UNIVERSITIES]: 'Ohne Universitäts-Kliniken',
  [AysClinicUniversityType.ONLY_UNIVERSITIES]: 'Nur Universitäts-Kliniken'
};
